<template>
    <ak-form-decorator
        :id="id"
        :title="title"
        :helpText="helpText"
        :error="error"
        :hasError="hasError"
        :required="required"
        :value="value"
        :locales="locales"
    >
        <div class="d-flex" ref="wrapper">
            <div class="ak-form__date-preview-wrapper">
                <span class="ak-icon ak-form__control-icon">event</span>

                <date-picker
                    type="date"
                    v-model="dates"
                    :multiple=true
                    :inline=true
                    :editable=false
                    :disabled=true
                    :placeholder="placeholder"
                    :lang="$getSetting('defaultLocale')"
                    input-class="ak-form__control ak-form__control--width-icon"
                    :class="{'ak-form__control--has-value': true}"
                    v-on="$currentListeners"
                    :style="{ width: datePickerWidth }"
                />
            </div>
        </div>
    </ak-form-decorator>
</template>

<script>
import FormElementMixin from "../../../../vendor/multimedium/spine/resources/spine-appkit-vue/src/components/form/mixins/FormElementMixin";

export default {
    name: 'ak-date-preview',
    mixins: [FormElementMixin],
    data() {
        return {
            removeFromListener: ['input','updateState','blur'],
            dates: [],
            datePickerWidth: 'auto',
        }
    },
    created() {
        this.dates = this.parseDates(this.value);
    },
    mounted() {
        this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                this.updateWidth();
            }
        });

        if (this.$refs.wrapper) {
            this.observer.observe(this.$refs.wrapper);
        }
    },
    beforeUnmount() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        updateWidth() {
            this.$nextTick(() => {
                if (this.$refs.wrapper && this.$refs.wrapper.offsetWidth > 0) {
                    this.datePickerWidth = `${this.$refs.wrapper.offsetWidth}px`;
                }
            });
        },
        parseDates(dateArray) {
            return dateArray.map(date => new Date(date));
        }
    },
    watch: {
        value: {
            handler(newValue) {
                this.dates = this.parseDates(newValue);
            },
            deep: true, // Ensures reactivity for nested changes (if `value` is an array)
            immediate: true // Triggers the watcher immediately after creation
        }
    }
}
</script>
